import { setCultureCookieValue, getCultureCookieValue } from '../utils/cookieUtilities';
var LanguageService = /** @class */ (function () {
    function LanguageService(vue) {
        this._vue = vue;
    }
    /**
     * Changes the application languge
     * 1. Sets the local storate 'lang' variable
     * 2. Sets the '_culture' cookie (used by the 'old' web, templateBase and the back-end code)
     * 3. Sets i18n locale language
     * @param lang language code ie. ('fi' or 'sv')
     */
    LanguageService.prototype.setLanguage = function (lang) {
        setCultureCookieValue(lang);
        this._vue.$i18n.locale = lang;
        document.documentElement.lang = lang;
        this._vue.$store.dispatch("vuexPageModule/setLanguage", lang);
    };
    LanguageService.prototype.initLanguage = function () {
        var lang = getCultureCookieValue();
        this.setLanguage(lang);
    };
    return LanguageService;
}());
export default LanguageService;
